import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';
import ModalDialog from './ModalDialog';
import ModalContent from './ModalContent';

export * from './ModalDialog/ModalDialog.types';

export default { ModalFooter, ModalHeader, ModalDialog, ModalContent };
